import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-Landing',
  templateUrl: './Landing.component.html',
  styleUrls: ['./Landing.component.scss'],
})
export class LandingComponent implements OnInit {
  selectedIndex = 0;
  interval: any;
  loginStatus: any;
  blogs: any = [
    {
      title: 'Why Enroll Considered A Stressbuster for Admission Management Team',
      content: 'Higher education institutions frequently experience stress related to meeting enrollment targets, a backlog of applications, and manual data input as the admissions season draws near.',
      image: './assets/images/blogs-images/enroll-stressbuster.jpg'
    },
    {
      title: 'Maximize Efficiency with Enroll’s Innovative AMS Modules',
      content: 'With the introduction of bi-annual admissions across universities, the University Grants Commission (UGC) has taken a major step toward improving accessibility and efficiency in higher education.',
      image: './assets/images/blogs-images/maximize-efficiency.jpeg'
    },
    {
      title: 'Unlock New Potential with Enroll’s Comprehensive AMS Solution',
      content: 'Empower your team with tools designed to streamline admissions. Enroll’s AMS software provides everything you need for a more organized, efficient, and stress-free admissions process.',
      image: './assets/images/card-three.png'
    },
  ];

  constructor(private router: Router) {
    this.router.navigateByUrl('/home');
  }

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.selectedIndex = (this.selectedIndex + 1) % 4; // Cycle through 0, 1, 2
    }, 3000);

    this.loginStatus = localStorage.getItem('self');
  }

  functions: any = [
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Track attendance with ease'
    },
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Schedule shifts effortlessly'
    },
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Track days off efficiently'
    },
    {
      icon: 'fa-regular fa-circle-check',
      content: 'Convert time to timesheets'
    }
  ];

  openOrganizaton() {
    this.router.navigateByUrl('organization');
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
